import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { FaqComponent } from './legal/faq/faq.component';
import { ImageAssetComponent } from './image-asset/image-asset.component';
import { LoadingComponent } from '../loading/loading.component';
import { PrivacyComponent } from './legal/privacy/privacy.component';
import { TermsComponent } from './legal/terms/terms.component';

import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { ListboxModule } from 'primeng/listbox';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DialogModule } from 'primeng/dialog';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        BlockUIModule,
        CheckboxModule,
        DialogModule,
        DropdownModule,
        ListboxModule,
        PanelModule,
        ProgressSpinnerModule,
        TooltipModule,
    ],
    declarations: [
        DocumentViewerComponent,
        FaqComponent,
        ImageAssetComponent,
        LoadingComponent,
        PrivacyComponent,
        TermsComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        ButtonModule,
        CheckboxModule,
        ConfirmDialogModule,
        DialogModule,
        DropdownModule,
        PanelModule,
        ProgressSpinnerModule,
        TooltipModule,

        BlockUIModule,
        ListboxModule,

        InfiniteScrollModule,

        DocumentViewerComponent,
        FaqComponent,
        ImageAssetComponent,
        LoadingComponent,
        PrivacyComponent,
        TermsComponent,
    ],
    providers: [
        DatePipe,
    ]
})
export class SharedUiModule {}
